import React from 'react';
import Search from './Search';
import DenialCodeInfoTab from './denialCodeInfo/DenialCodeInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class DenialCodeSetup extends React.Component {
    render() {
        let opts = {
            setupKey: "DenialCode",
            title: "Denial Codes",
            description: "Create, modify, and remove Denial Codes",
            addNewTitle: "Add new Denial Code",
            addPrivilege: App.hasPrivilege("AdminDenialCodeSetupAdd"),
            enableColumnSettings: true,
            showTitle: false,
            recentType: "DenialCode",
            list: {
                url: API.App.url('/DenialCodeSetup/search'),
                rowKey: "denialCodeId",
                columns: [
                    { key: 'code', name: 'Code', width: 100, sortable: true },
                    { key: 'description', name: 'Description' }
                ]
            },
            tabs: [
                { key: "DenialCode", title: "Denial Code", comp: DenialCodeInfoTab },
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default DenialCodeSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/denialCodeSetup/DenialCodeSetup.js